/**
 * Finds the last element in an array that satisfies the provided testing function.
 *
 * @param array - The array to search through.
 * @param predicate - A function that tests each element of the array.
 * @returns The last element in the array that satisfies the testing function, or undefined if no element satisfies the function.
 *
 * @todo Use `Array.findLast` when ECMAScript target in `tsconfig.json` has been at least raised to "ES2023" or "ESNext".
 */
export const findLast = <T>(array: T[], predicate: (value: T, index: number, obj: T[]) => boolean): T | undefined => {
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicate(array[i], i, array)) {
            return array[i];
        }
    }

    return undefined;
};
